import { useState } from 'react';
import './Products.css';

export const Products = () => {
  const [selectedCard, setSelectedCard] = useState<string | null>(null);

  const handleCardClick = (cardId: string) => {
    setSelectedCard(cardId === selectedCard ? null : cardId);
  };

  return (
    <section className="products" id="produtos">
      <div className="container">
        <div className="products-intro">
          <div className="products-badge">Nossos Serviços</div>
          <h2 className="products-heading">Nossas Soluções Tecnológicas</h2>
          <p className="products-description">
            Nossa plataforma oferece soluções inovadoras para suas necessidades de negócio. 
            Conheça nossas ferramentas e descubra como podemos ajudar sua empresa a crescer.
          </p>
        </div>

        <div className="services-grid">
          <div 
            className={`service-card service-card-main ${selectedCard === 'tarefas-perto' ? 'selected' : ''}`}
            onClick={() => handleCardClick('tarefas-perto')}
          >
            <div className="service-card-content">
              <h3>Tarefas Perto</h3>
              <p>
                Encontre serviços próximos, feche contratos com segurança e expanda sua renda com a inteligência 
                do Tarefas Perto.
              </p>
              <a href="/tarefas-perto" className="service-link" onClick={(e) => e.stopPropagation()}>Saiba mais</a>
            </div>
            
            <div className="service-images-wrapper">
              <div className="service-image service-image-primary">
                <img src="/images/tarefas1.jpeg" alt="Tarefas Perto" />
              </div>
              <div className="service-image service-image-secondary">
                <img src="/images/tarefas2.jpeg" alt="Tarefas Perto - Funcionalidades" />
              </div>
            </div>
          </div>

          <div 
            className={`service-card ${selectedCard === 'em-breve' ? 'selected' : ''}`}
            onClick={() => handleCardClick('em-breve')}
          >
            <div className="service-image service-image-coming-soon">
              <img src="/images/embreve.jpg" alt="Em Breve" className="blurred-image" />
            </div>
            <h3>Em Breve</h3>
            <p>
              Estamos sempre desenvolvendo novas soluções para tornar negócios mais inteligentes e eficientes. 
              Fique de olho nas próximas novidades.
            </p>
            <a href="#" className="service-link" onClick={(e) => e.stopPropagation()}>Notifique-me</a>
          </div>
        </div>
        
        <div className="services-cta">
          <a href="#produtos-detalhes" className="button primary">Conheça nossos serviços</a>
        </div>
      </div>
    </section>
  );
}; 